import { removeFromAssortment } from '../actions/routines';

const masterTable = (state = {}, action) => {
    switch (action.type) {
        case 'FETCH_PRODUCTS':
            return { ...state, ...action.data };
        case 'PRODUCTS_FETCHED':
            return {
                ...state,
                products: action.data.products,
                hasMyList: action.data.hasMyList,
                hasMore: action.data.hasMore,
                currentPage: action.data.currentPage,
            };
        case 'PRODUCTS_COUNTER_FETCHED':
            return {
                ...state,
                total: action.data.total,
                myTotal: action.data.myTotal,
                ksTotal: action.data.ksTotal,
                maSupplierTotal: action.data.maSupplierTotal,
                myFavorite: action.data.myFavorite,
                totalWithPromotionFilter: action.data.totalWithPromotionFilter,
                totalWithoutPromotionFilter:
                    action.data.totalWithoutPromotionFilter,
                totalWithBonusDragend: action.data.totalWithBonusDragend,
                totalWithoutBonusDragend: action.data.totalWithoutBonusDragend,
            };
        case removeFromAssortment.SUCCESS:
            return {
                ...state,
                products: action.payload.data,
                total: action.payload.total,
                maSupplierTotal: action.payload.maSupplierTotal,
                hasMyList: action.payload.hasMyList,
                hasMore: action.payload.hasMore,
                currentPage: action.payload.currentPage,
                totalWithPromotionFilter:
                    action.payload.totalWithPromotionFilter,
                totalWithoutPromotionFilter:
                    action.payload.totalWithoutPromotionFilter,
                totalWithBonusDragend: action.payload.totalWithBonusDragend,
                totalWithoutBonusDragend:
                    action.payload.totalWithoutBonusDragend,
            };
        default:
            return state;
    }
};

export default masterTable;
